export const ReactionsEnums = {
  CONFETTI: 'confetti',
  CLINKIN_GLASSES: 'clinking-glasses'
}
